import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { athleteProfilesAPI } from '../lib/api';
import { ProfileAvatar } from './ProfileAvatar';
import { ChevronDown, Check } from 'lucide-react';
import { toast } from 'sonner';

export default function AthleteProfileSwitcher() {
  const { user, switchAthleteProfile } = useAuth();
  const [profiles, setProfiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [switching, setSwitching] = useState(false);

  useEffect(() => {
    loadProfiles();
  }, [user?.id]);

  const loadProfiles = async () => {
    try {
      const res = await athleteProfilesAPI.getProfiles();
      setProfiles(res.data.profiles || []);
    } catch {
      // ignora — se fallisce non mostra il switcher
    }
  };

  // Mostra il componente solo se ci sono 2+ profili
  if (profiles.length < 2) return null;

  const handleSwitch = async (profileId) => {
    if (profileId === user?.id || switching) return;
    setSwitching(true);
    setOpen(false);
    try {
      await switchAthleteProfile(profileId);
      toast.success('Profilo cambiato');
      window.location.reload();
    } catch {
      toast.error('Errore nel cambio profilo');
    } finally {
      setSwitching(false);
    }
  };

  return (
    <div className="relative w-full">
      <button
        onClick={() => setOpen((o) => !o)}
        disabled={switching}
        className="w-full flex items-center gap-2 bg-zinc-900 border border-white/10 rounded-xl px-3 py-2 hover:border-[#ccff00]/40 transition-colors"
      >
        <ProfileAvatar name={user?.name} photo={user?.profile_photo} size="xs" />
        <span className="text-white text-sm font-medium flex-1 text-left truncate">{user?.name}</span>
        <ChevronDown className={`w-3.5 h-3.5 text-zinc-400 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 right-0 top-full mt-2 z-50 bg-zinc-900 border border-white/10 rounded-xl overflow-hidden shadow-xl">
            <p className="text-zinc-500 text-[10px] uppercase tracking-wide px-3 pt-3 pb-1">Cambia profilo</p>
            {profiles.map((profile) => (
              <button
                key={profile.id}
                onClick={() => handleSwitch(profile.id)}
                className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-zinc-800 transition-colors text-left"
              >
                <ProfileAvatar name={profile.name} photo={profile.profile_photo} size="xs" />
                <div className="flex-1 min-w-0">
                  <p className="text-white text-sm font-medium truncate">{profile.name}</p>
                  {profile.athlete_code && (
                    <p className="text-zinc-500 text-[10px] font-mono">{profile.athlete_code}</p>
                  )}
                </div>
                {profile.id === user?.id && (
                  <Check className="w-3.5 h-3.5 text-[#ccff00] flex-shrink-0" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
